export default ({ name, checked, value, type }) => ({
  name,
  value: type === 'checkbox' ? checked : value,
});
